import Home from './pages/Home'
import { ThirdwebProvider, ChainId } from '@thirdweb-dev/react'
// react-toastify
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

function App() {
  return (
    <>
      <ThirdwebProvider desiredChainId={ChainId.Goerli}>
        <ToastContainer />
        <Home />
      </ThirdwebProvider>
    </>
  )
}

export default App
